/**
 * For exporting html to pdf. Svg elements must be specified (via svgContainersSelector param) for export to work.
 * Specified svg containers will be converted to images on export.
 *
 * @param {string} exportElementSelector - css selector for root element that contains html that will be exported
 * @param {Node} headerElement - html element that contains header for report
 * @param {string} svgContainersSelector - css selector for svg containers that are converted to images on export
 * @param {string} skipElementsSelector - css selector for elements that will be skipped on export
 * @param {string} exportFilename - name of exported pdf
 *
 * TODO: enable specifying footer for pdf
 *
 **/

import { savePDF } from "@progress/kendo-react-pdf";
import html2canvas from "html2canvas";
import moment from "moment";

// helper functions
let _exportToPdfFinal;
let _createExportClone;
let _exportWithSvgContainers;

export const exportHtmlToPdf = (
  exportElementSelector,
  headerElement,
  svgContainersSelector,
  skipElementsSelector,
  exportFilename = `report-${moment().format("YYYY-MM-DD")}.pdf`
) => {
  const exportElement = document.querySelector(exportElementSelector);

  if (!svgContainersSelector && !skipElementsSelector && !headerElement) {
    _exportToPdfFinal(exportElement, exportFilename);
  } else if (!svgContainersSelector) {
    const exportClone = _createExportClone(exportElement, headerElement);
    _exportToPdfFinal(exportClone, exportFilename, skipElementsSelector, true);
  } else {
    const exportClone = _createExportClone(exportElement, headerElement);
    _exportWithSvgContainers(
      exportClone,
      svgContainersSelector,
      skipElementsSelector,
      exportFilename
    );
  }
};

_exportToPdfFinal = (node, fileName, skip, removeNode = false) => {
  [].slice.call(node.querySelectorAll(skip)).forEach(el => el.remove());
  savePDF(
    node,
    {
      margin: { left: 40, right: 40, top: 30, bottom: 30 },
      imageTimeout: 750,
      fileName
    },
    () => removeNode && node.remove()
  );
};

_createExportClone = (exportElement, headerElement) => {
  const exportContainer = document.createElement("div");
  // container is hidden and styled in a way that allows it to be used with html2canvas and kendo savePDF
  exportContainer.style.width = "1700px";
  exportContainer.style.position = "absolute";
  exportContainer.style.top = 0;
  exportContainer.style.left = "-100000px";

  const exportClone = exportElement.cloneNode(true);
  if (headerElement) {
    exportContainer.append(headerElement);
  }
  exportContainer.append(exportClone);

  exportElement.parentElement.append(exportContainer);

  return exportContainer;
};

_exportWithSvgContainers = (
  exportNode,
  svgContainersSelector,
  skipElementsSelector,
  exportFilename
) => {
  const svgContainers = [].slice.call(
    exportNode.querySelectorAll(svgContainersSelector)
  );

  svgContainers.forEach(svgContainer => {
    html2canvas(svgContainer, {
      onclone: cloneTemp => {
        // workaround for wrong canvas cutoff
        [].slice
          .call(
            cloneTemp.querySelectorAll("html2canvaspseudoelement:first-child")
          )
          .forEach(el => el.remove());
      }
    })
      .then(canvas => {
        svgContainer.parentNode.replaceChild(canvas, svgContainer);
      })
      .then(() => {
        if (!exportNode.querySelectorAll(svgContainersSelector).length) {
          _exportToPdfFinal(
            exportNode,
            exportFilename,
            skipElementsSelector,
            true
          );
        }
      });
  });
};
